import { History, Location } from 'history';
import * as React from 'react';

import { KeyedObject } from 'bernie-core/dist/source';
import { mergeQueryString, updateSearch } from 'bernie-core';

import { ActivitySearchStore, FILTER_URL_PARAM_PREFIX } from '../../../stores';

import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';

import { getFilteredObjectKeys } from '../../../helpers/common-helper';

export const SEE_ALL_CATEGORY = 'seeAll';
export const PRICE_CATEGORY = 'price';
export const CATEGORIES = 'categories';

export const getUpdatedFilterQueryObject = (activitySearchStore: ActivitySearchStore): any => {
  const filterQueryObject: KeyedObject = {};
  getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters).forEach((sortAndFilterKey) => {
    const filterKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[sortAndFilterKey]);
    const filterParamKey = FILTER_URL_PARAM_PREFIX + sortAndFilterKey;
    const filteredKeys = filterKeys.filter(
      (filterKey) => activitySearchStore.sortAndFilterObject.filters[sortAndFilterKey][filterKey].selected
    );
    if (
      sortAndFilterKey === CATEGORIES &&
      activitySearchStore.selectedCategories &&
      activitySearchStore.selectedCategories.length > 0
    ) {
      activitySearchStore.selectedCategories.forEach((element: string) => {
        filteredKeys.push(element);
      });
    }
    if (sortAndFilterKey === SEE_ALL_CATEGORY && filteredKeys.length > 0) {
      filterQueryObject[filterParamKey] = true;
    } else {
      filterQueryObject[filterParamKey] = filteredKeys.join(',');
    }
  });

  return filterQueryObject;
};

export function seeAllCheckboxClickHandler(
  filterKey: string,
  filterCategoryId: string,
  activitySearchStore: ActivitySearchStore,
  history: History,
  location: Location,
  event: React.ChangeEvent<HTMLInputElement>,
  inDialog?: boolean
): void {
  const { checked } = event.target;
  const updatedFilterState = { ...activitySearchStore.sortAndFilterObject.filters };
  updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = { selected: checked, enabled: true };
  if (checked) {
    const filterState = { selected: !checked, enabled: true };
    const categoryKeys = getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters);
    categoryKeys
      .filter((categoryKey) => categoryKey !== SEE_ALL_CATEGORY)
      .forEach((categoryKey) =>
        getFilteredObjectKeys(activitySearchStore.sortAndFilterObject.filters[categoryKey]).forEach(
          (filterKey) => (updatedFilterState[categoryKey][filterKey] = filterState)
        )
      );
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    const newQueryString = mergeQueryString(location.search, {
      ...getUpdatedFilterQueryObject(activitySearchStore)
    });
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  }
}

export function checkboxClickHandler(
  filterKey: string,
  filterCategoryId: string,
  activitySearchStore: ActivitySearchStore,
  history: History,
  location: Location,
  event: React.ChangeEvent<HTMLInputElement>,
  inDialog?: boolean
): void {
  const { checked } = event.target;
  const updatedFilterState = { ...activitySearchStore.sortAndFilterObject.filters };
  if (checked) {
    updatedFilterState[filterCategoryId][filterKey] = { selected: checked, enabled: true };
    if (updatedFilterState[SEE_ALL_CATEGORY]) {
      updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = { selected: !checked, enabled: true };
    }
  }

  if (!checked) {
    const subCategoryKeys = getFilteredObjectKeys(
      activitySearchStore.sortAndFilterObject.filters[filterCategoryId],
      filterKey
    );
    subCategoryKeys.forEach((subCategory) => {
      updatedFilterState[filterCategoryId][subCategory] = { selected: checked, enabled: true };
    });
  }
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;
  if (!inDialog) {
    const newQueryString = mergeQueryString(location.search, {
      ...getUpdatedFilterQueryObject(activitySearchStore)
    });
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  }
}

export function radioFilterClickHandler(
  fieldId: string,
  fieldVal: string,
  activitySearchStore: ActivitySearchStore,
  history: History,
  location: Location,
  inDialog?: boolean
): void {
  const updatedFilterState = { ...activitySearchStore.sortAndFilterObject.filters };
  Object.keys(updatedFilterState[fieldId]).forEach((filter) => {
    updatedFilterState[fieldId][filter].selected = false;
  });
  if (updatedFilterState[SEE_ALL_CATEGORY]) {
    updatedFilterState[SEE_ALL_CATEGORY][SEE_ALL_CATEGORY] = { selected: false, enabled: true };
  }
  updatedFilterState[fieldId][fieldVal].selected = true;
  activitySearchStore.sortAndFilterObject.filters = updatedFilterState;

  if (!inDialog) {
    const newQueryString = mergeQueryString(location.search, {
      ...getUpdatedFilterQueryObject(activitySearchStore)
    });
    updateSearch({
      history: history,
      location: location,
      newParams: newQueryString,
      newState: {},
      replace: true
    });
  }
}

export function getSelectedFieldValue(
  field: ActivityDestinationViewSearch.ShoppingSelectionFieldInlineFragment,
  activitySearchStore: ActivitySearchStore
): string {
  if (!field?.primary) {
    return '';
  }
  const sortAndFilterObject =
    activitySearchStore.sortAndFilterObject.filters[(field?.options && field.options[0]?.id) || ''];
  const filterKeys = Object.keys(sortAndFilterObject);
  const selectedKeys = filterKeys.filter((filter) => sortAndFilterObject[filter].selected === true);

  return selectedKeys.length > 0 ? selectedKeys[0] : filterKeys[0];
}
